import type { ChartClickData, ChartWidgetConfig } from "../../types/chart"
import { AGGREGATION_TYPE, METRIC_OUTPUT_TYPE } from "../../types/core"
import { resolveDataSource } from "../dataSource"

const CHART_LEVEL_AGGREGATED_VALUE = "all matching rows"
const CHART_LEVEL_DISPLAY_LABEL = "Entire chart"

const getChartLevelDisplayLabel = (config: ChartWidgetConfig) =>
  config.title?.trim() || CHART_LEVEL_DISPLAY_LABEL

export function buildChartLevelDrillDownClickData(input: {
  config: ChartWidgetConfig
  dateRange?: { start: Date; end: Date } | null
}): ChartClickData | null {
  const { config, dateRange } = input
  const metricId = config.metricId

  if (!metricId || !dateRange?.start || !dateRange.end) {
    return null
  }

  return {
    drillDownScope: "chart",
    timestamp: dateRange.start.getTime(),
    bucketTime: dateRange.start.toISOString(),
    endDate: dateRange.end.toISOString(),
    metricId,
    dataSource: resolveDataSource(config),
    aggregation: config.aggregation ?? AGGREGATION_TYPE.AVG,
    metricOutputType: config.metricOutputType ?? METRIC_OUTPUT_TYPE.FLOAT,
    bucketInterval: config.bucketInterval,
    filters: config.filters,
    metricFilter: config.metricFilter,
    aggregatedValue: CHART_LEVEL_AGGREGATED_VALUE,
    displayLabel: getChartLevelDisplayLabel(config),
  }
}
